module.exports = __webpack_public_path__ + "static/media/so.99aa087b.png";